import axios from 'axios';

import { type Common } from '../common.js';
import {
  type FilterOptions,
  type Finding,
  type UpdateFindingValues,
} from '../models/patient/finding.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options: FilterOptions): Promise<Finding[]> {
    const url = this.common.constructPath(`/patient-findings`, options);
    return await this.common.getJSON(url);
  }

  async get(findingId: string): Promise<Finding> {
    const url = this.common.constructPath(`/patient-findings/${findingId}`);
    return await this.common.getJSON(url);
  }

  async update(findingId: string, values: UpdateFindingValues): Promise<Finding> {
    const url = this.common.constructPath(`/patient-findings/${findingId}`);
    return await this.common.patchJSON(url, values);
  }

  async uploadCareGapFindings(formData: FormData) {
    const url = this.common.constructPath(`/patient-findings/upload/care-gap`);
    return await axios.put(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
    });
  }

  async uploadHccFindings(formData: FormData) {
    const url = this.common.constructPath(`/patient-findings/upload/hcc`);
    return await axios.put(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    });
  }
}
